import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { FaAngleLeft } from "react-icons/fa";

export default function PaymentQR() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const amount = state?.amount || 0;
  const plan = state?.plan || "";
  const users = state?.users || 1;
  const cycle = state?.cycle || "";

  return (
    <div style={{ width: "100%", minHeight: "100vh", background: "#f7f7f7" }}>
      
      {/* HEADER */}
        <div className="page-header">
        <div className="header-left">
         <button className="back-icon" onClick={() => navigate(-1)}>
            <FaAngleLeft size={20} />
</button>
          <img
            src={require("./assets/meet.png")}
            alt="Logo"
            className="header-logo"
          />

         
        </div>
      </div>
      {/* BODY */}
      <div style={{  textAlign: "center" }}>
        
        <h3 style={{ fontSize: 22, marginBottom: 10 }}>
          Scan to Pay / Join
        </h3>

        <p style={{ fontSize: 18, marginBottom: 20 }}>
          {plan} — {users} User(s)
        </p>

        <h2 style={{ fontSize: 32, marginBottom: 25, fontWeight: 700 }}>
          ₹{amount}
        </h2>

        {/* QR Code Box */}
        <div
          style={{
            width: 230,
            margin: "auto",
            background: "#fff",
            padding: 15,
            borderRadius: 10,
            boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
          }}
        >
          <QRCode value={`https://example.com/pay?amount=${amount}`} size={200} />
        </div>
      </div>
    </div>
  );
}
